<script setup lang="ts">
import { watch } from 'vue'
import { useEditorStore } from '@/stores/Editor'
import { BackgroundTheme } from '@/api/interfaces'
import { useTranslate } from '@tolgee/vue'

import ColorPicker from '@/components/common/ColorPicker.vue'

const editorStore = useEditorStore()
const { t } = useTranslate('local')

watch(
  () => editorStore.editor.background.themeColor.background,
  (color) => {
    editorStore.editor.hero.image.overlayColor = color
  },
)
</script>

<template>
  <p class="mb-2">{{ t(`EditorBackgroundSettings.theme.custom.description`) }}</p>
  <ColorPicker
    v-model="editorStore.editor.background.themeColor.background"
    :disabled="
      editorStore.publishLoading || editorStore.editor.background.theme !== BackgroundTheme.CUSTOM
    "
  />
</template>

<style lang="scss" scoped></style>
